import React from "react";
import { PdfPreview26 } from "./components/pdfPreview";

export const TextoRcCruzada26 = () => <PdfPreview26 />;
